
export enum SaveState {
    Unchanged = 0,
    Saving = 1,
    Saved = 2
}
